import React from 'react';
import GrayCard from '../../../components/GrayCard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'c3/c3.css';
import './Compliance.css';
import {
    getComplianceMember,getComplianceVendor,getComplianceYearFilter,tabTracking
} from '../../../actions';
import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';
import _findIndex from 'lodash/findIndex';
import { PriceFormatter, dynamicDateFilters1, monthName1, differenceFormatter1, PercentFormatter1, PriceFormatter1, DateFormatter, escapeDoubleQuotes, jsonToParam, paramsToJSON, paramsToJSON1 } from '../../../helper';
import { differenceFormatter } from '../../../helper';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Filters from '../../../components/Filters.jsx';
import { getCardTitle, VirtualizedPriceFormatter, VirtualizedDifferenceFormatter,formatCurrency,
    formatPounds ,formatUnits,RvRenderMultipleVolumeCell
} from '../../../helper';
import accounting from 'accounting-js';
import { matLoader } from '../../../components/Loader';
import ReactExport from "react-export-excel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import Select from 'react-select';
import { Row, Col, Button, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { ROOT_URL } from '../../../actions';
import Axios from 'axios';

function jsonToParamMonth(param, startWith) {
    if (param) {
        let paramArr = [];
        Object.keys(param).forEach(function (key) {
            if (typeof param[key] != 'object')
                paramArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(param[key]));
        });
        return startWith ? startWith + paramArr.join('&') : paramArr.join('&');
    } else {
        return '';
    }
}

function renderTooltip(text, props) {
    return (
        <Tooltip id="button-tooltip" {...props}>
            {text}
            Simple tooltip
        </Tooltip>
    );
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie(cname) {
    return getCookie(cname) && getCookie(cname) !== '';
}
class Compliance extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            selectedFilterPeriod: "YTD",
            buttonOptionsPeriod: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval: [],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            isLoading: true,
            params: {
               // source: "verified",
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 12,
                quarter: 1,
                // buyingGroupId: 0,
                // isCompliant: "A",
                // subTabVendor: "Sales",
                // subTabMember: "Purchase",
                // memberId: "",
                // vendorId: "",
                // startRowNo: 0
            },
            expanded: false,
           
        }

    }
 

    handleUserSelectedFilter(option) {
        // let params = this.state.params;
        // params = paramsToJSON1(params);
                let obj = {};
         
            if (option === "qtr" || option === "QTR") {
                this.setState({ showQuarter: true });
            } else {
                this.setState({ showQuarter: false });
            }
           
        let paramsValues = this.state.params;
        let paramsfinal = paramsToJSON1(paramsValues);
        let month = paramsfinal.month;
        
        if(month >= 1 && month <= 3){
            paramsfinal.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            paramsfinal.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            paramsfinal.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            paramsfinal.quarter = 4
        }
        
        let params = jsonToParam(paramsfinal);
            this.setState({ selectedFilterPeriod: option , params: params}, () => {
            this.setFilter({ period: this.state.selectedFilterPeriod, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }

    componentWillMount() {

        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }
    componentDidMount() {
        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptionsPeriod: ["YTD", "QTR"], selectedFilterPeriod: "YTD" });
        }
        Promise.all([
            this.props.getComplianceYearFilterAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=11"),
            // this.props.getComplianceMemberAPI(this.state.params),
            // this.props.getComplianceVendorAPI(this.state.params),

        ]).then(result  => {
            this.getOptionsYear();
                this.setState({isLoading: false})
            
        })
            .catch(err => {
                this.setState({
                    isLoading: false
                })
            })
           
    }
    componentWillUnmount() {
    this._isMounted = false;
  }

    loadMore = (index) => {
        console.log('index in load more', index)
        this.actuallyLoadMore(index.startIndex + 1)
        return new Promise((resolve, reject) => {
            this.promiseResolve = resolve;
        })
    }
    handleChangeOfDropdown(event) {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
                let obj = {};
                obj[event.name] = event.value;
                params.quarter = event.value;
                let quarter = params.quarter
                
                params = jsonToParam(params);
                this.setState({
                    quarter:quarter,
                    params: params})
                this.setState(obj, () => {
                    this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
                });
        
            }
    handleChangeOfDropdownMonth = (e) => {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month
        let selectedItem = { label: monthName1(month), value: month }
       // let month = selectedItem.value;
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })
        console.log(this.state.selectedItem);
        this.props.getComplianceMemberAPI(params)
        this.props.getComplianceVendorAPI(params)


    }

    setFilter = (filter) => {

        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            // params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {

            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        else if (filter.buyingGroupId != undefined || filter.isCompliant == undefined) {
            params.buyingGroupId = filter.buyingGroupId;
            params.isCompliant = params.isCompliant;

        }
        else if (filter.isCompliant != undefined || filter.buyingGroupId == undefined) {
            params.isCompliant = filter.isCompliant;
            params.buyingGroupId = params.buyingGroupId;

        }
        params = jsonToParam(params);

        this.setState({
            buyingGroupId: params.buyingGroupId,
            isCompliant: params.isCompliant,
            params: params,
            refreshData: true,
            isLoading: true,

        }, () => Promise.all([
            this.props.getComplianceMemberAPI(params),
        this.props.getComplianceVendorAPI(params),

        ]).then(([groupRebateData]) => {
            this.setState({
                isLoading: false,
                groupRebatesListData: groupRebateData
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))
    }


    handleChangeOfDropdownYear(e) {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        params.year = e.value
        year = params.year
        let selectedYear = { label: year, value: year }

        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
        }, this.getOptions)

        console.log(this.state.selectedYear);
        this.props.getComplianceMemberAPI(params)
        this.props.getComplianceVendorAPI(params)

    }
    getOptionsYear() {
        
        let dataval = Object.values(this.props.getComplianceYearFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
        }
         //add this new code
         else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        params.year = selectedYear.value;
        params = jsonToParam(params);

        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
             params: params ,
        })
        this.props.getComplianceMemberAPI(this.state.params)
        this.props.getComplianceVendorAPI(this.state.params)
    }
//     getOptions() {
// 
//         let params = this.state.params;
//         params = paramsToJSON(params);
//         let items = []
//         let items1 = []
//         items = this.props.getComplianceYearFilter[params.year].map(itemval => {
//             return {
//                 label: monthName1(itemval),
//                 value: itemval,
//             }

//         })

//         let selectedItem = items[items.length - 1];
//         params.month = selectedItem.value;
//        let month = selectedItem.value;
//         if(month >= 1 && month <= 3){
//             params.quarter= 1
//         }
//         else if(month >= 4 && month <= 6){
//             params.quarter = 2
//         }
//         else if(month >= 7 && month <= 9){
//             params.quarter = 3
//         }
//         else if(month >= 10 && month <= 12){
//             params.quarter = 4
//         }
//         params = jsonToParam(params);
//         this.setState({
//             items: items,
//             selectedItem: selectedItem,
//             params: params,
//         })

//         // this.props.getComplianceMemberAPI(params)
//         // this.props.getComplianceVendorAPI(params)
//         
//     }


    renderButtonGroup() {

        return this.state.buttonOptionsPeriod.map((option, index) => {
            return (
                <button style ={{height:'38px'}} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilterPeriod === option) ? "active" : null}`}>{option}</button>
            )
        })
    }

    handleChangeOfDropdownextra(event) {
        let obj = {};
        obj[event.name] = event.value;
        this.setState(obj, () => {
            this.setFilter({ buyingGroupId: this.state.buyingGroupId, isCompliant: this.state.isCompliant });
            // params= jsonToParam(params);
        });
    }

    selectRowProp = {
        mode: "radio",
        hideSelectColumn: true,
        clickToSelect: true,
        hideSelectAll: true,
        bgColor: "rgb(0,0,255)",
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect) {
                return true;
            }
        }
    };
   

// Poungds, sales, unit calculation  ended
    renderSizePerPageDropDown = props => {
        return (
          <div className='btn-group'>
            {
              [ 25, 50, 100 ].map((n, idx) => {
                const isActive = (n === props.currSizePerPage) ? 'active' : null;
                return (
                  <button key={ idx } type='button' className={ `btn btn-info ${isActive}` } onClick={ () => props.changeSizePerPage(n) }>{ n }</button>
                );
              })
            }
          </div>
        );
      }
    
    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }

    render() {

        const { showQuarter } = this.state;
        const { monthName } = this.props;
        this.corporateOverviewVPPerformance = [];
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        let params = this.state.params;
        params = paramsToJSON(params);
        
        return (
            <div>
             <ToastContainer style={{zIndex: '9999'}}  />
                <nav className="Filters navbar">
                    <div style={{ marginLeft: "60px", fontVariantCaps: 'petite-caps' }}>
                        <span className="navbar-brand nav-head" >COMPLIANCE</span></div>
                
                    <div className="export-button-wrapper-overview" style={{ marginRight: "0px", width: "100px !important " }}>
                        <ul className="navbar-nav flexRowForFilters" >
                            {/* <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li> */}
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />

                               
                            </li>
                            {/* {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style ={{height:'38px',width:'80px'}} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={ params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={ params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={ params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={ params.quarter == 4 ? true : false} >QTR4</option>
                                    </select>

                                </li>
                                :
                                <li className = "nav-item">
                                     <select className="form-control" style={{ width: '80px', height: '37px' }} onChange={(e) => { console.log(e.target.value); this.handleChangeOfDropdownMonth({ name: "month", value: e.target.value }) }}>
                                    <option value="1" selected={this.state.monthName == "Jan" ? true : false}>Jan</option>
                                    <option value="2" selected={this.state.monthName == "Feb" ? true : false}>Feb</option>
                                    <option value="3" selected={this.state.monthName == "Mar" ? true : false}>Mar</option>
                                    <option value="4" selected={this.state.monthName == "Apr" ? true : false}>Apr</option>
                                    <option value="5" selected={this.state.monthName == "May" ? true : false}>May</option>
                                    <option value="6" selected={this.state.monthName == "Jun" ? true : false}>Jun</option>
                                    <option value="7" selected={this.state.monthName == "Jul" ? true : false}>Jul</option>
                                    <option value="8" selected={this.state.monthName == "Aug" ? true : false}>Aug</option>
                                    <option value="9" selected={this.state.monthName == "Sep" ? true : false}>Sep</option>
                                    <option value="10" selected={this.state.monthName == "Oct" ? true : false}>Oct</option>
                                    <option value="11" selected={this.state.monthName == "Nov" ? true : false}>Nov</option>
                                    <option value="12" selected={this.state.monthName == "Dec" ? true : false}>Dec</option>
                                </select>

                                </li>
                            } */}


                        </ul>
                        <ExcelFile filename="COMPLIANCE DATA" element={<button className="btn btn-primary" style={{ marginRight: "60px" ,height:'38px',marginLeft:'4px'}}>Export</button>}>
                            <ExcelSheet data={this.props.getComplianceMember} name="MEMBER DETAILS">
                            <ExcelColumn label="MEMBER ID" value="groupId" />

                                <ExcelColumn label="NAME" value="name" />
                                <ExcelColumn label="COMPANY NAME" value="groupName" />
                                <ExcelColumn label="COMPLIANCE NAME" value="complianceStatus" />
                                <ExcelColumn label="lAST TRANSACTION FILE UPLOAD" value="lastTransactionUpload" />
                                <ExcelColumn label="FIRST TRANSACTION DATE" value="dataMinDate" />
                                <ExcelColumn label="LAST TRANSACTION DATE" value="dataMaxDate" />
                                <ExcelColumn label="NO. OF TIME DASHBOARD LOGIN" value="loginCount" />
                                <ExcelColumn label="EMAIL ID" value="email" />
                               
                            </ExcelSheet>
                            <ExcelSheet data={this.props.getComplianceVendor} name=" SUPPLIER DETAILS">
                            <ExcelColumn label="VENDOR ID" value="groupId" />

                            <ExcelColumn label="NAME" value="name" />
                                <ExcelColumn label="COMPANY NAME" value="groupName" />
                                <ExcelColumn label="COMPLIANCE NAME" value="complianceStatus" />
                                <ExcelColumn label="lAST TRANSACTION FILE UPLOAD" value="lastTransactionUpload" />
                                <ExcelColumn label="FIRST TRANSACTION DATE" value="dataMinDate" />
                                <ExcelColumn label="LAST TRANSACTION DATE" value="dataMaxDate" />
                                <ExcelColumn label="NO. OF TIME DASHBOARD LOGIN" value="loginCount" />
                                <ExcelColumn label="EMAIL ID" value="email" />
                            </ExcelSheet>
                        </ExcelFile>
                    </div>

                </nav>
                {this.state.isLoading ? matLoader() : <div>
                
                    <div className="card shadow-sm mb-3" style={{ marginLeft: "60px", marginRight: "60px" }}>
                            <div className="card-body">
                                <h5 style={{ textDecorationLine: 'underline', fontSize: '15px',marginBottom:'-20px' }}>Member Details</h5>
                                <BootstrapTable height='400' data={this.props.getComplianceMember} striped hover version="4" search multiColumnSearch >

                                   <TableHeaderColumn width="100" thStyle={{ whiteSpace: 'normal' }}  tdStyle={{ whiteSpace: 'normal' }} isKey dataSort={true} dataField='groupId'>Member Id</TableHeaderColumn>
                                <TableHeaderColumn width="100" thStyle={{ whiteSpace: 'normal' }}  tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} dataField='name'>Name</TableHeaderColumn>
                                    <TableHeaderColumn width="150"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='groupName'>Company Name</TableHeaderColumn>
                                    <TableHeaderColumn width="150"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='complianceStatus'>Compliance Status</TableHeaderColumn>
                                    <TableHeaderColumn width="130"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={DateFormatter} dataSort={true} dataField='lastTransactionUpload'>Last PAT Transaction File Upload</TableHeaderColumn>
                                    <TableHeaderColumn width="100"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='email'>Email Id</TableHeaderColumn>
                                    <TableHeaderColumn width="100"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={DateFormatter} dataSort={true} dataField='dataMinDate'>First Transaction date</TableHeaderColumn>
                                    <TableHeaderColumn width="120"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat = {DateFormatter} dataSort={true} dataField='dataMaxDate'>Last Transaction date</TableHeaderColumn>
                                    <TableHeaderColumn width="120"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='loginCount'>No. Of Time Dashboard Login</TableHeaderColumn>
                                   

                                </BootstrapTable>  
                    
                             </div>

              
                    </div> 

                    
                    <div className="card shadow-sm mb-3" style={{ marginLeft: "60px", marginRight: "60px" }}>
                    {/* complianceStatus: "Non-Compliant"
dataMaxDate: null
dataMinDate: null
email: ""
firstTransactionUpload: null
groupName: "A.O. Smith Water Products Company"
lastCatalogUpload: "2020-04-14T22:52:12"
lastTransactionUpload: null
loginCount: 3
name: " "
phone: "" */}
                            <div className="card-body">
                                <h5 style={{ textDecorationLine: 'underline', fontSize: '15px', marginBottom:'-20px'}}>Supplier Details</h5>
                                <BootstrapTable height='400' data={this.props.getComplianceVendor} striped hover version="4" search multiColumnSearch >
                                    <TableHeaderColumn width="100" thStyle={{ whiteSpace: 'normal' }}  tdStyle={{ whiteSpace: 'normal' }} isKey dataSort={true} dataField='groupId'>Vendor Id</TableHeaderColumn>
                                    <TableHeaderColumn width="100" thStyle={{ whiteSpace: 'normal' }}  tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='name'>Name</TableHeaderColumn>
                                    <TableHeaderColumn width="150"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='groupName'>Company Name</TableHeaderColumn>
                                    <TableHeaderColumn width="150"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='complianceStatus'>Compliance Status</TableHeaderColumn>
                                    <TableHeaderColumn width="130"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={DateFormatter} dataSort={true} dataField='lastTransactionUpload'>Last PAT Transaction File Upload</TableHeaderColumn>
                                    <TableHeaderColumn width="100"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='email'>Email Id</TableHeaderColumn>
                                    <TableHeaderColumn width="100"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={DateFormatter} dataSort={true} dataField='dataMinDate'>First Transaction date</TableHeaderColumn>
                                    <TableHeaderColumn width="120"  thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat = {DateFormatter} dataSort={true} dataField='dataMaxDate'>Last Transaction date</TableHeaderColumn>
                                    <TableHeaderColumn width="120" thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat = {DateFormatter} dataSort={true} dataField='lastCatalogUpload'>Last Product Catalog Upload</TableHeaderColumn>
                                    <TableHeaderColumn width="100" thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  dataSort={true} dataField='loginCount'>No. Of Time Dashboard Login</TableHeaderColumn>

                                </BootstrapTable>  
                    
                             </div>

              
                    </div> 
            </div> }
            </div>

        )
    }
}
function mapStateToProps(state) {


    return {
      
        getComplianceMember: _get(state, 'corporate.getComplianceMember', []),
        getComplianceVendor: _get(state, 'corporate.getComplianceVendor', []),
        getComplianceYearFilter: _get(state, 'corporate.getComplianceYearFilter', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),
        
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getComplianceMemberAPI: getComplianceMember,
        getComplianceVendorAPI: getComplianceVendor,
        getComplianceYearFilterAPI: getComplianceYearFilter,
        tabTrackingAPI:tabTracking,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Compliance);
